// A BELSŐ topbar harangja — a KÖZÖS `NotificationBellBase` bekötése a belső felület route-fájára és
// szövegeire (a Mo-csillag és az avatar között: `components/shared/app-shell.tsx`).
//
// A felépítés (panel-geometria, csontváz, hiba-/üres-állapot, végtelen görgetés, footer) a vázban él, mert a
// partner-portál ugyanezt kéri — lásd `notification-bell-base.tsx` fejléce. Ami ITT dől el: a mélylink
// feloldása (`ref-to-route.ts`), az ÉLŐ jelzés (`useNotificationStream` — SSE, csak belső tokennel) és a
// tegező szövegek.
import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useNotificationFeed } from '../hooks/use-notification-feed';
import { useNotificationStream } from '../hooks/use-notification-stream';
import { navigateToNotificationRoute, refToRoute, type NotificationRoute } from '../ref-to-route';
import { NotificationBellBase } from './notification-bell-base';

export function NotificationBell(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // A jelvény-szám a KÖZÖS feed-queryből jön (a váz is ezt olvassa — egy query, egy igazság); itt csak az
  // aria-szövegek interpolációjához kell.
  const { unreadCount } = useNotificationFeed();
  useNotificationStream();

  return (
    <NotificationBellBase<NotificationRoute>
      texts={{
        triggerTitle: t('nav.notifications'),
        triggerAria: t('notify.bell.aria'),
        triggerAriaWithCount: t('notify.bell.ariaWithCount', { unread: unreadCount }),
        panelTitle: t('notify.panel.title'),
        markAll: t('notify.panel.markAll'),
        emptyTitle: t('notify.panel.emptyTitle'),
        emptyDescription: t('notify.panel.emptyDescription'),
        errorTitle: t('notify.panel.errorTitle'),
        errorDescription: t('notify.panel.errorDescription'),
        loading: t('notify.panel.loading'),
        liveCount: t('notify.bell.liveCount', { unread: unreadCount }),
        openList: t('notify.panel.openMessages'),
      }}
      resolveRoute={refToRoute}
      // A BELSŐ felületen nincs fiók-scope, tehát a sor nem kell a navigáláshoz.
      navigateToRoute={(route) => navigateToNotificationRoute(navigate, route)}
      onOpenList={() => void navigate({ to: '/messages' })}
    />
  );
}
